// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"3114b2fa","453":"cb92c59e","667":"f316d18a"}[chunkId] + ".chunk.js";
};